import { state } from "./state";
import { mutations } from "./mutations";
import { actions } from "./actions";

export default {
  state,
  mutations,
  actions,
};

export {
  GET_ALL_INVOICES,
  RESET_INVOICES,
  UPDATE_ALL_INVOICES,
} from "./actions";
